import { render } from "./ProductInfo.vue?vue&type=template&id=7836685e&scoped=true"
import script from "./ProductInfo.vue?vue&type=script&lang=js"
export * from "./ProductInfo.vue?vue&type=script&lang=js"

import "./ProductInfo.vue?vue&type=style&index=0&id=7836685e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7836685e"

export default script